<template>
  <div class="bar">
    <el-menu :default-active="activeIndex"
             class="el-menu-demo"
             mode="horizontal"
             @select="handleSelect"
             router>
      <template v-for="(item) in barlist">
        <el-menu-item :index="item.path"
                      :key="item.key"
                      v-if="item.children.length===0">
          {{item.name}}
        </el-menu-item>
        <el-submenu :index="item.path"
                    v-else
                    :key="item.key + item.key">
          <template slot="title">{{item.name}}</template>
          <el-menu-item :index="it.path"
                        v-for="(it) in item.children"
                        :key="it.key">
            {{it.name}}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'bar',
  data () {
    return {
      activeIndex: 'index',
      barlist: [
        {
          name: '首页',
          path: '/index',
          key: 'index',
          auth: true,
          children: []
        },
        {
          name: '乐家市场',
          path: '/market',
          key: 'market1',
          auth: true,
          children: [

          ]
        },
        // {
        //   name: '乐家桌面',
        //   path: '/desktop',
        //   key: 'desktop',
        //   auth: true,
        //   children: [
        //     // {
        //     //   name: '乐家桌面',
        //     //   path: '/desktop',
        //     //   key: 'desktop',
        //     //   auth: true
        //     // },
        //     // {
        //     //   name: '乐家桌面管理后台',
        //     //   path: '/home',
        //     //   key: 'home',
        //     //   auth: true
        //     // }
        //   ]
        // },
        {
          name: '乐家市场分享码',
          path: '/group-list',
          key: 'sharingcode',
          auth: true,
          children: []
        },
        // {
        //   name: '乐家桌面管理后台',
        //   path: '/ljmange',
        //   key: 'ljmange',
        //   auth: true,
        //   children: []
        // },
        {
          name: '乐家固件平台',
          path: '/ljfirmware',
          key: 'ljfirmware',
          auth: true,
          children: []
        },
        {
          name: '开发者',
          path: '/rom-list',
          key: 'romList',
          auth: true,
          children: []
        }
        // ,
        // {
        //   name: '关于我们',
        //   path: '/aboutus',
        //   key: 'about',
        //   auth: true,
        //   children: []
        // }
      ]
    }
  },
  components: {},
  // 钩子函数: 数据监听
  watch: {
  },
  created: function () {

  },
  mounted () {
    this.activeIndex = location.pathname ? location.pathname : 'index'
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key === '/ljmange') {
        window.open('https://launcher.xuntu56.com/launcher/#/login')
      } else if (key === '/ljfirmware') {
        window.open('https://tvrom.lejiamk.com')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bar {
  //  font-family: Roboto, sans-serif;
  background-color: #fafafa;
  //   color: #333;
  margin: 0;
  display: block;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  font-weight: 700;
}
/deep/ .el-menu--horizontal {
  display: flex;
  justify-content: center;
  border-bottom: 0;
}
/deep/ .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #409EFF;
}
/deep/ .el-menu--horizontal > .el-menu-item {
  height: 80px;
  line-height: 80px;
  color: #333333;
  padding: 0 30px;
  font-size: 16px;
  &:hover {
    color: #2777f8;
  }
}
/deep/ .el-submenu .el-submenu__title {
  height: 80px;
  line-height: 80px;
  color: #333333;
  font-size: 16px;
  &:hover {
    color: #2777f8;
  }
}
/deep/ .is-active {
  color: #2777f8 !important;
  .el-submenu__title {
    color: #2777f8 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/bar/index.vue